import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 md:py-24 bg-[#0a0e1a]" data-id="element-173">
      <div className="max-w-3xl mx-auto px-6" data-id="element-174">
        <FadeIn data-id="element-175">
          <div className="card-glass rounded-md p-10 md:p-14 text-center relative" style={{
          borderColor: 'rgba(201,168,76,0.4)'
        }} data-id="element-176">
            <div className="flex justify-center mb-8" data-id="element-177">
              <div className="relative" data-id="element-178">
                <div className="absolute inset-0 bg-gold-500/30 blur-2xl rounded-full" data-id="element-179"></div>
                <div className="relative w-24 h-24 rounded-full flex items-center justify-center bg-[#0d1527] border-2 border-gold-500" data-id="element-180">
                  <ShieldCheckIcon className="w-12 h-12 text-gold-400" strokeWidth={1.5} data-id="element-181" />
                </div>
              </div>
            </div>

            <p className="text-sm uppercase tracking-widest text-gold-400 mb-3 font-medium" data-id="element-182">
              Compra sin riesgo
            </p>
            <h2 className="text-3xl md:text-4xl font-serif mb-6 text-glow" data-id="element-183">
              Garantía Total de 30 Días
            </h2>
            <p className="text-body-xl text-cream-muted max-w-xl mx-auto leading-relaxed" data-id="element-184">
              Si en 30 días no duermes mejor, te devolvemos cada centavo. Sin
              preguntas. Sin complicaciones.
            </p>
            <p className="mt-6 text-gold-400 text-lg font-medium" data-id="element-185">
              El riesgo es 100% nuestro.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}